export default __webpack_public_path__ + "communication_results.png";